function toHoursMinutesFormatter(value: number) {
  
  
  const hours = Math.floor(value / 60);
  const minutes = value % 60;
  if (hours > 0) {
    return `${hours}h ${minutes}m`;
  } else {
    return `${minutes}m`;
  }
}

export default toHoursMinutesFormatter;
